/**
 * API document type values for key party identification documents.
 * Must match AllDocumentTypes in sid-investor-svc (note the British
 * spelling of "driving-licence" — it is the canonical value platform-wide).
 */
export const KEY_PARTY_DOCUMENT_TYPES = {
  PASSPORT: "passport",
  DRIVING_LICENCE: "driving-licence",
} as const;

/**
 * Values of the ID Document Type select in CompleteIndividualDialog.
 */
export const KEY_PARTY_ID_TYPES = {
  PASSPORT: "passport",
  DRIVERS_LICENSE: "drivers-license",
} as const;

/**
 * Local uploader slot keys (DocumentState.documentType) that discriminate the
 * dropzones in CompleteIndividualDialog. Not sent to the API — on submit they
 * are mapped to KEY_PARTY_DOCUMENT_TYPES plus a side.
 */
export const KEY_PARTY_UPLOADER_KEYS = {
  PASSPORT: "passport",
  DRIVERS_LICENSE_FRONT: "drivers-license-front",
  DRIVERS_LICENSE_BACK: "drivers-license-back",
} as const;
